export const ubavis = {
  id: 1,
  visiondata:
    "Unnat Bharat Abhiyan is inspired by the vision of transformational change in rural development processes by leveraging knowledge institutions to help build the architecture of an Inclusive India.",
};

export const ubamis = [
  {
    id: 1,
    mission:
      "The Mission of Unnat Bharat Abhiyan is to enable higher educational institutions to work with the people of rural India in identifying development challenges and evolving appropriate solutions for accelerating sustainable growth.",
  },
  {
    id: 2,
    mission:
      "It also aims to create a virtuous cycle between society and an inclusive academic system by providing knowledge and practices for emerging professions and to upgrade the capabilities of both the public and the private sectors in responding to the development needs of rural India.",
  },
];

export const ubagoal = [
  {
    id: 1,
    point:
      "To build an understanding of the development agenda within institutes of Higher Education and an institutional capacity and training relevant to national needs, especially those of rural India.",
  },
  {
    id: 2,
    point: "To re-emphasize the need for field work, stake-holder interactions and design for societal objectives as the basis of higher education.",
  },
  {
    id: 3,
    point: "To stress on rigorous reporting and useful outputs as central to developing new professions.",
  },
  {
    id: 4,
    point: "To provide rural India and regional agencies with access to the professional resources of the institutes of higher education, especially those that have acquired academic excellence in the field of science, engineering and technology, and management.",
  },
  {
    id: 5,
    point: "To improve development outcomes as a consequence of this research. To develop new professions and new processes to sustain and absorb the outcomes of research.",
  },
  {
    id: 6,
    point: "To foster a new dialogue within the larger community on science, society and the environment and to develop a sense of dignity and collective destiny.",
  },
];
